module.exports = __webpack_public_path__ + "img/art-61.49ca6a1e.png";